// extracted by mini-css-extract-plugin
export default {"doc-link":"CNsTGnupDQ","docLink":"CNsTGnupDQ"};